// assets/ss-notify.js
(function () {
  if (window.SS_NOTIFY && window.SS_NOTIFY.show) return;

  // Debug ALWAYS ON (matches your current approach)
  const DEBUG = true;

  function dbg() {
    if (!DEBUG) return;
    try {
      console.log.apply(console, ["[SS_NOTIFY]"].concat([].slice.call(arguments)));
    } catch (e) {}
  }

  function getHeaderEl() {
    return (
      document.querySelector(".site-header") ||
      document.querySelector("header") ||
      document.querySelector(".header") ||
      null
    );
  }

  function iconSvg(type, color) {
    // error/info icon OR success/check icon
    if (type === "success") {
      return `
        <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" focusable="false">
          <circle cx="11" cy="11" r="9.5" fill="none" stroke="${color}" stroke-width="2"></circle>
          <path d="M6.6 11.3l2.7 2.8 6.2-6.4" fill="none" stroke="${color}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path>
        </svg>
      `;
    }

    // default: "error" -> info icon
    return `
      <svg width="22" height="22" viewBox="0 0 22 22" aria-hidden="true" focusable="false">
        <circle cx="11" cy="11" r="9.5" fill="none" stroke="${color}" stroke-width="2"></circle>
        <line x1="11" y1="10" x2="11" y2="16" stroke="${color}" stroke-width="2" stroke-linecap="round"></line>
        <circle cx="11" cy="7" r="1.2" fill="${color}"></circle>
      </svg>
    `;
  }

  function isMobileHeader() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  // Try hard to find the header search area (desktop)
  function getSearchAnchorEl() {
    // Empire typically has a search form/input in the header
    const input =
      document.querySelector('.site-header input[type="search"]') ||
      document.querySelector('.site-header input[name="q"]') ||
      document.querySelector('input[type="search"]') ||
      document.querySelector('input[name="q"]');

    if (input) {
      // Use the input itself (best vertical centering) or its form
      return input.closest("form") || input;
    }

    return (
      document.querySelector('.site-header form[action*="/search"]') ||
      document.querySelector('form[action*="/search"]') ||
      null
    );
  }

  // Try hard to find the logo area (mobile)
  function getLogoAnchorEl() {
    return (
      document.querySelector(".site-header .site-header-logo") ||
      document.querySelector(".site-header .site-header__logo") ||
      document.querySelector(".site-header a[href='/']") ||
      document.querySelector(".site-header a[href='/'] img")?.closest("a") ||
      null
    );
  }

  /**
   * show(message, type, options)
   * type: "error" | "success"
   */
  function show(message, type, options) {
    const opts = options || {};
    const variant = type === "success" ? "success" : "error";
    const color = variant === "success" ? "#008000" : "#FC3E01";
    const visibleMs = typeof opts.visibleMs === "number" ? opts.visibleMs : 2200;

    dbg("show called", { message, variant, visibleMs });

    try {
      const id = opts.id || "ss-global-toast";
      const headerEl = getHeaderEl();

      const parent = document.body;
      if (!parent) {
        dbg("no body yet; retrying");
        setTimeout(() => show(message, variant, opts), 50);
        return;
      }

      // Remove any existing toast with same id
      const existing = document.getElementById(id);
      if (existing && existing.parentNode) existing.parentNode.removeChild(existing);

      const el = document.createElement("div");
      el.id = id;

      // Position fixed, centered under header (works regardless of scroll)
      const calcTop = () => {
        if (!headerEl) return 16;
        const r = headerEl.getBoundingClientRect();
        return Math.max(0, Math.round(r.bottom)) + 10;
      };

      el.style.boxSizing = "border-box";
      el.style.fontFamily = "Arial, sans-serif";
      el.style.pointerEvents = "auto";

      el.style.position = "fixed";
      el.style.top = "0px";
      el.style.left = "0px";
      el.style.right = "auto";
      el.style.maxWidth = "520px";
      el.style.width = "min(520px, calc(100vw - 32px))";
      el.style.zIndex = "2147483647";

      // Banner style (same look as you built, but color is parameterized)
      el.style.padding = "14px 16px";
      el.style.borderRadius = "3px";
      el.style.border = `2px solid ${color}`;
      el.style.background = "rgba(255, 255, 255, 0.90)";
      el.style.boxShadow = "0 10px 26px rgba(0,0,0,0.12)";
      el.style.fontSize = "14px";
      el.style.fontWeight = "600";
      el.style.letterSpacing = "0.1px";
      el.style.lineHeight = "1.35";
      el.style.color = color;

      // Show immediately (preserve centering transform)
      el.style.opacity = "1";
      el.style.transform = "translateY(0)";
      el.style.transition = "opacity 180ms ease, transform 180ms ease";

      // Layout: left (icon+message) + right (X)
      el.textContent = "";
      el.style.display = "flex";
      el.style.alignItems = "center";
      el.style.justifyContent = "space-between";
      el.style.gap = "12px";

      const leftWrap = document.createElement("div");
      leftWrap.style.display = "flex";
      leftWrap.style.alignItems = "center";
      leftWrap.style.gap = "12px";
      leftWrap.style.minWidth = "0";

      const iconEl = document.createElement("span");
      iconEl.style.flex = "0 0 auto";
      iconEl.style.width = "22px";
      iconEl.style.height = "22px";
      iconEl.style.display = "inline-flex";
      iconEl.style.alignItems = "center";
      iconEl.style.justifyContent = "center";
      iconEl.innerHTML = iconSvg(variant, color);

      const msgEl = document.createElement("div");
      msgEl.textContent = message;
      msgEl.style.flex = "1";
      msgEl.style.minWidth = "0";
      msgEl.style.whiteSpace = "normal";
      msgEl.style.overflow = "visible";
      msgEl.style.textOverflow = "clip";

      leftWrap.appendChild(iconEl);
      leftWrap.appendChild(msgEl);

      const closeEl = document.createElement("button");
      closeEl.type = "button";
      closeEl.setAttribute("aria-label", "Dismiss");
      closeEl.textContent = "×";
      closeEl.style.pointerEvents = "auto";
      closeEl.style.border = "0";
      closeEl.style.background = "transparent";
      closeEl.style.color = color;
      closeEl.style.fontSize = "20px";
      closeEl.style.lineHeight = "1";
      closeEl.style.fontWeight = "800";
      closeEl.style.cursor = "pointer";
      closeEl.style.padding = "0";
      closeEl.style.margin = "0";
      closeEl.style.opacity = "0.95";

      function cleanup() {
        window.removeEventListener("resize", reposition);
        window.removeEventListener("scroll", reposition);
      }

      function reposition() {
        const mobile = isMobileHeader();
        const anchorEl = mobile ? getLogoAnchorEl() : getSearchAnchorEl();

        // Fallback to old behavior if we can’t find the anchor
        if (!anchorEl) {
          const headerEl = getHeaderEl();
          const top = headerEl
            ? Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom)) + 10
            : 16;

          el.style.left = "50%";
          el.style.right = "auto";
          el.style.top = top + "px";
          el.style.transform = "translateX(-50%)";
          return;
        }

        const r = anchorEl.getBoundingClientRect();

        // We want vertical center of the 46px bar (or whatever it is), and respect header padding naturally
        const toastH = el.offsetHeight || 0;
        const toastW = el.offsetWidth || 0;

        const minPad = 10;   // you said header top padding is 10px
        const sidePad = 10;

        // Target vertical center of the anchor
        let top = Math.round(r.top + r.height / 2);

        // Clamp so it never goes off-screen
        if (toastH) {
          top = Math.max(minPad + toastH / 2, Math.min(top, window.innerHeight - minPad - toastH / 2));
        }

        el.style.top = top + "px";

        if (mobile) {
          // On mobile: center on the logo area
          let cx = Math.round(r.left + r.width / 2);
          if (toastW) {
            cx = Math.max(sidePad + toastW / 2, Math.min(cx, window.innerWidth - sidePad - toastW / 2));
          }
          el.style.left = cx + "px";
          el.style.right = "auto";
          el.style.transform = "translate(-50%, -50%)";
        } else {
          // On desktop: align to the RIGHT edge of the search bar, vertically centered within it
          let right = Math.round(window.innerWidth - r.right);
          if (toastW) {
            right = Math.max(sidePad, Math.min(right, window.innerWidth - sidePad - toastW));
          }
          el.style.right = right + "px";
          el.style.left = "auto";
          el.style.transform = "translateY(-50%)";
        }
      }


      closeEl.addEventListener("click", () => {
        el.style.opacity = "0";
        el.style.transform = "translateY(6px)";
        setTimeout(() => {
          cleanup();
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 240);
      });

      el.appendChild(leftWrap);
      el.appendChild(closeEl);
      parent.appendChild(el);
      requestAnimationFrame(reposition);

      // Keep pinned below header if sticky header changes size
      window.addEventListener("resize", reposition);
      window.addEventListener("scroll", reposition, { passive: true });

      // Auto-hide
      setTimeout(() => {
        el.style.opacity = "0";
        el.style.transform = "translateY(6px)";
        setTimeout(() => {
          cleanup();
          if (el.parentNode) el.parentNode.removeChild(el);
        }, 240);
      }, visibleMs);
    } catch (e) {
      console.warn("[SS_NOTIFY] show failed:", e);
      alert(message);
    }
  }

  window.SS_NOTIFY = { show };

  dbg("SS_NOTIFY ready");
})();
